import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { BlockType } from '../../@types/BlockType';
import { SceneCodeSetting } from '../setting/SceneCodeSetting';
import { block_translation } from '../../lang/BlockTranslation';

const t = block_translation;

export class ArSceneStartBlock extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.AR_SCENE_START, t.to('ARシーンスタート', 'ar_scene_start'));
    this.setNameForCode('a-scene');
    this.setLibrary(`../public/libs/mindar-image.prod.js`);
    this.setLibrary(`../public/libs/aframe.min.js`);
    this.setLibrary(`../public/helper_bundle.js`);
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setSceneColor(block);
    ShapeSettings.setSceneStartShape(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeOfSceneStartInput(block);
    ShapeSettings.addStatementInput(block);
  }

  generateStaticHTMLCode(block: BlockType): string {
    const html = `<a id="myEnterARButton" href="#"></a>`;
    return html;
  }

  codeGenerateCore(block: BlockType): string {
    // シーンの属性
    let attribute = '';
    attribute += CodeSetting.getSubAttributeCode(block);
    const str = SceneCodeSetting.getSceneCode(attribute, block);
    return str;
  }
}
